import React from 'react';
import InfoContainerMD from '../../core/infoContainerMD';
import { Container, Typography } from "@mui/material";
import { incidentsHeadings } from '../configs/incidentsInfoConfig';
import { studentInfo } from "../configs/studentDetailsCardConfig";
import { styles } from "../styles/incidentInfoTab";
import { useTheme } from "@mui/material/styles";
import IncidentLocationMap from "./incidentLocationMap";
import IncidentPhotoEvidence from "./incidentPhotoEvidence";
import IncidentTranslation from "./incidentTranslation";
import IncidentTrustedAdult from "./incidentTrustedAdult";
import DeAnonymizePanel from "./deAnonymizePanel";


const IncidentInfoTab = ({data, handleOpen, updating, setUpdating }) => {
    const theme = useTheme();
    const style = styles(theme);
    return (
        <>
            <IncidentTrustedAdult data={data} />
            <IncidentTranslation data={data} />
            <IncidentLocationMap location={data.location} />
            <IncidentPhotoEvidence imageUrls={data.imageUrls} imageMeta={data.imageMeta} imageMetaRaw={data.imageMetaRaw} />
            <DeAnonymizePanel data={data} />
            {data.studentData && (
                <Container sx={style.studentInfoContainer}>
                    <Container sx={style.studentInfoHeader}>
                        <Typography sx={style.studentInfoTitle}>
                            Student Personal Information
                        </Typography>
                    </Container>
                    <InfoContainerMD
                        config={[
                            // Class schedule note only when the server sent one (emergency reports).
                            ...studentInfo.filter((f) => f.field !== 'schedule' || data.studentData.schedule),
                            // Phase 4: gender from school records, sent by the server on emergency reports only.
                            ...(data.studentData.gender
                                ? [{ field: 'gender', heading: 'Gender (school records)', editable: false, column: 1 }]
                                : []),
                        ]}
                        infoData={data.studentData}
                    />
                </Container>
            )}
            <InfoContainerMD
                config={incidentsHeadings}
                infoData={data}
                isIncident={true}
                handleOpen={handleOpen}
                updating={updating}
                setUpdating={setUpdating}
                type={"incidents"}
            />
        </>
    );
};

export default IncidentInfoTab;